import { Mesh, PlaneBufferGeometry, Vector2, Vector4 } from 'three';
import { SphereItemType } from 'shared/interfaces/planogram';
import BaseObject3D from 'shared/object3d/BaseObject3D';
const geometry = new PlaneBufferGeometry(1, 1);
export default class ImageObject3D extends BaseObject3D {
    constructor() {
        super();
        this.itemType = SphereItemType.Image;
        this.itemType = SphereItemType.Image;
        this.mesh = new Mesh(geometry);
        this.add(this.mesh);
        this.userData.mesh = this.mesh;
    }
    configure(imageConfig, material) {
        this.mesh.material = material;
        const { cropOffset, cropRatio, cornerRadius } = imageConfig;
        material.setItemUniforms({
            cropOffset: { value: new Vector2(...(cropOffset !== null && cropOffset !== void 0 ? cropOffset : [0, 0])) },
            cropRatio: { value: new Vector2(...(cropRatio !== null && cropRatio !== void 0 ? cropRatio : [1, 1])) },
            cornerRadius: { value: new Vector4(...(cornerRadius !== null && cornerRadius !== void 0 ? cornerRadius : [0, 0, 0, 0])) },
        });
    }
}
